import type { PlanName } from '~/services/interfaceService';

/**
 * Parses a plan name string to extract structured plan details.
 *
 * This function handles multiple plan formats:
 * 1. Legacy Plans: 'pro' or 'launch' are parsed into their respective plan names with an undefined duration.
 * 2. Free Plan: 'free' is mapped directly to the 'Free' plan.
 * 3. Standard Plans: Hyphenated strings like 'pro-monthly' or 'launch-discounted-annual' are broken down to determine the plan's base name, duration, and whether it's discounted.
 *
 * @param planName The raw plan name string.
 * @returns An object containing the parsed `planName`, `duration`, and `isDiscounted` status.
 */

export const planNameCleaner = (
  planName: PlanName,
): {
  planName: 'Pro' | 'Launch' | 'Custom' | 'Free';
  duration: 'Monthly' | 'Yearly' | undefined;
  isDiscounted: boolean;
} => {
  const lowerCasePlanName = planName.toLowerCase();

  console.log('[planNameCleaner] planName', planName);

  // Legacy Plans (without hyphen)
  if (lowerCasePlanName === 'pro' || lowerCasePlanName === 'launch') {
    return {
      planName: planName as 'Pro' | 'Launch',
      duration: undefined,
      isDiscounted: false,
    };
  }

  // Free Plan
  if (lowerCasePlanName === 'free') {
    return {
      planName: 'Free',
      duration: undefined,
      isDiscounted: false,
    };
  }

  // New Plans
  const parts = lowerCasePlanName.split('-');
  const isDiscounted = parts.includes('discounted');

  let planBase: 'Pro' | 'Launch' | 'Custom' = 'Custom';

  if (parts.includes('pro')) {
    planBase = 'Pro';
  } else if (parts.includes('launch')) {
    planBase = 'Launch';
  }

  let duration: 'Monthly' | 'Yearly' | undefined;

  if (parts.includes('monthly')) {
    duration = 'Monthly';
  } else if (parts.includes('yearly') || parts.includes('annual')) {
    duration = 'Yearly';
  }

  const planData = {
    planName: planBase,
    duration,
    isDiscounted,
  };

  console.log('[planNameCleaner] planData', planData);

  return planData;
};
